export default __webpack_public_path__ + "static/Exo2-Bold-1def2e83fc90b1fb733b7e2ba4eec7de.ttf";